import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asset'
})
export class AssetPipe implements PipeTransform {
  transform(value: string, dir?: string): string {
    if (dir) {
      return `//assets.francisli.com/${dir}/${value}`;
    }
    return `//assets.francisli.com/${value}`;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/asset.pipe.ts